import React from 'react';
import { getCurrency } from "../config/utils";
import { dateIso2Us } from '../config/dateUtils';
import { useSxStyles    } from "../styles/sxStyles";
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid2 from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip'
import Zoom from '@mui/material/Zoom'

const NameListItem = (props) => {
    const balance = props.balance;
    const selectNameBalance = props.selectNameBalance;
    const classes = useSxStyles;

    return (
        (<ListItem alignItems='flex-start' sx={classes.listPadding}>
            <ListItemText
                sx={classes.listText}
                primary={
                    <Grid2
                        container
                        spacing={1}
                        alignItems="top"
                        sx={{width: '100%'}}
                    >
                        <Grid2
                            size={{
                                xs: 3,
                                lg: 2
                            }}>
                            <Tooltip title='Use this item for lookup' arrow slots={{
                                transition: Zoom
                            }}>
                                <Button
                                    variant='contained'
                                    color='success'
                                    onClick={() => selectNameBalance(balance)}
                                    sx={classes.tinyButton}
                                >
                                    Select
                                </Button>
                            </Tooltip>
                        </Grid2>
                        <Grid2
                            size={{
                                xs: 5,
                                lg: 2
                            }}>
                            {
                                balance.party.partyName ? balance.party.partyName :
                                    `${balance.party.lastName}, ${balance.party.firstName}`
                            }
                        </Grid2>
                        <Grid2
                            size={{
                                xs: 4,
                                lg: 2
                            }}>
                            {dateIso2Us(balance.party.dob)}
                        </Grid2>
                        <Grid2
                            size={{
                                xs: 4,
                                lg: 2
                            }}>
                            {balance.caseNumber}
                        </Grid2>
                        <Grid2
                            size={{
                                xs: 4,
                                lg: 2
                            }}>
                            {balance.citationNumber}
                        </Grid2>
                        <Grid2
                            sx={{textAlign: 'right'}}
                            size={{
                                xs: 4,
                                lg: 2
                            }}>
                            {getCurrency(balance.courtAmount)}
                        </Grid2>
                    </Grid2>
                }
                slotProps={{
                    primary: {sx: classes.smallText}
                }}
            />
        </ListItem>)
    );
}

export default NameListItem;
